export enum QuestionDefaultAnswersCount {
  PUZ_MATCHING_ANSWERS_COUNT = 2,
  TWO_COLUMN_ANSWERS_COUNT = 2,
  PICTURE_ROUND_ANSWERS_COUNT = 10,
  CHOOSE_TEN_ANSWERS_COUNT = 10,
}
